import { getContenidoNodesForTab, normalizeCourseTabName } from "./normalizeCourseShape";

/**
 * @param {unknown} tabName
 * @param {number} index
 * @returns {string}
 */
export function courseTabRemovalLabel(tabName, index) {
  const named = normalizeCourseTabName(tabName);
  return named || `Pestaña ${index + 1}`;
}

/**
 * A tab has content when its temario has sections/files or a test is assigned to it.
 * @param {unknown} tabName
 * @param {unknown} bloquesContenido
 * @param {unknown} tests
 * @returns {boolean}
 */
export function courseTabHasContent(tabName, bloquesContenido, tests) {
  if (getContenidoNodesForTab(bloquesContenido, typeof tabName === "string" ? tabName : "").length > 0) {
    return true;
  }

  const rawKey = typeof tabName === "string" ? tabName : "";
  const rawNodes =
    bloquesContenido && typeof bloquesContenido === "object" && !Array.isArray(bloquesContenido)
      ? bloquesContenido[rawKey]
      : null;
  if (Array.isArray(rawNodes) && rawNodes.length > 0) {
    return true;
  }

  const wanted = normalizeCourseTabName(tabName);
  if (!Array.isArray(tests)) {
    return false;
  }

  return tests.some((test) => {
    const pestanas = test && typeof test === "object" && Array.isArray(test.pestanas) ? test.pestanas : [];
    return pestanas.some((pestana) => {
      if (pestana === tabName) {
        return true;
      }
      const normalized = normalizeCourseTabName(pestana);
      return Boolean(wanted) && normalized === wanted;
    });
  });
}

/**
 * Tabs that would disappear when the count drops, and that still have content.
 * @param {unknown} tabs
 * @param {number} nextCount
 * @param {unknown} bloquesContenido
 * @param {unknown} tests
 * @returns {Array<{ name: string, index: number, label: string }>}
 */
export function listTabsWithContentOnReduction(tabs, nextCount, bloquesContenido, tests) {
  if (!Array.isArray(tabs) || !Number.isInteger(nextCount) || nextCount < 0 || nextCount >= tabs.length) {
    return [];
  }

  /** @type {Array<{ name: string, index: number, label: string }>} */
  const pending = [];
  for (let index = nextCount; index < tabs.length; index += 1) {
    const name = typeof tabs[index] === "string" ? tabs[index] : "";
    if (!courseTabHasContent(name, bloquesContenido, tests)) {
      continue;
    }
    pending.push({
      name,
      index,
      label: courseTabRemovalLabel(name, index),
    });
  }
  return pending;
}

/**
 * @param {Array<{ label: string }>} tabsWithContent
 * @param {(message: string) => boolean} confirmFn
 * @returns {boolean}
 */
export function confirmTabsWithContent(tabsWithContent, confirmFn) {
  for (const tab of tabsWithContent) {
    const accepted = confirmFn(`Se eliminará la pestaña ${tab.label} y su contenido. ¿Continuar?`);
    if (!accepted) {
      return false;
    }
  }
  return true;
}
